import { FormEvent, useEffect, useMemo, useState } from 'react';
import Select, { SingleValue } from 'react-select';
import countryList from 'react-select-country-list';
import INetworkAnalystSearchParams from 'src/types/INetworkAnalyst';

interface Props {
  search: (searchParams: INetworkAnalystSearchParams) => void;
  type: 'business' | 'individual';
}

const SearchForm: (props: Props) => JSX.Element = (props: Props) => {
  const defaultSearchParams: INetworkAnalystSearchParams = {
    name: '',
    country: null,
    dateOfBirth: '',
  };
  const [searchParameters, setSearchParameters] = useState<INetworkAnalystSearchParams>({
    ...defaultSearchParams,
  });
  const [countrySelectValue, setCountrySelectValue] = useState(defaultSearchParams.country);

  const options: any = useMemo(() => countryList().getData(), []);

  // Clear form inputs if the section changes
  useEffect(() => {
    setSearchParameters({...defaultSearchParams});
    setCountrySelectValue(defaultSearchParams.country);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.type]);

  /**
   * This function performs the basic validation before screening
   * @param e
   */
  const search = (e: FormEvent) => {
    e.preventDefault();
    let valid = true;
    /**
     * First validate the input
     */
    if (!searchParameters.name) valid = false;
    /*******************************/
    valid && props.search(searchParameters);
  };

  const clear = () => {
    setSearchParameters({ ...defaultSearchParams });
    setCountrySelectValue(defaultSearchParams.country);
  };

  return (
    <div>
      {/* Business Light Screening Page */}
      <div className="col-lg-12 card top-head p-0 overflow-visible">
        <div className="py-4 px-4">
          <form onSubmit={search}>
            <div className="d-flex gap-3 ew-cols align-items-end flex-wrap">
              <div className="flex-grow-1">
                <label className="form-label">{ props.type === 'business' ? 'Company' : 'Full' } Name*</label>
                <input
                  name="name"
                  className="form-control"
                  type="text"
                  placeholder="Enter name"
                  required
                  value={searchParameters.name}
                  onChange={(e) => {
                    setSearchParameters({ ...searchParameters, name: e.target.value });
                  }}
                />
              </div>

              {
                props.type === 'individual'
                ? (
                  <div className="flex-grow-1">
                    <label className="form-label">Year of Birth (YYYY)</label>
                    <input
                      name="date_of_birth"
                      className="form-control"
                      placeholder="Enter year of birth (YYYY)"
                      type="text"
                      inputMode="numeric"
                      pattern="\d{4}"
                      minLength={4}
                      maxLength={4}
                      value={searchParameters.dateOfBirth}
                      onChange={(e) => {
                        // Keep only digits, cap at 4
                        let value = e.target.value.replace(/\D/g, "").slice(0, 4);
                        setSearchParameters({ ...searchParameters, dateOfBirth: value });
                      }}
                    />
                  </div>
                ) : null
              }
              
              <div className="flex-grow-1">
                <label className="form-label">Country</label>
                <Select
                  className="dynamic-countries"
                  name="country"
                  options={options}
                  value={countrySelectValue}
                  onChange={(value: SingleValue<{ label: string, value: string }>) => {
                    setCountrySelectValue(value as any);
                    setSearchParameters({
                      ...searchParameters,
                      country: value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="additional-fields mt-8" data-testid="additional-fields">
              <div className="d-flex flex-wrap justify-content-end align-items-center">
                <div className="button-group">
                  <button
                    type="button"
                    name="clearBtn"
                    className="button btn-ghost"
                    onClick={clear}
                  >
                    Clear
                  </button>
                  
                  <button type="submit" className="button btn-with-icon">
                    <img
                      src={require('src/assets/images/icons/search-icon.svg').default}
                      alt=""
                    />
                    Search
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SearchForm;
